import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'

export interface ActiveCampaignTag {
  tag: string
  id: number
}

export function useAddTag() {
  const {client, event} = useEvent()

  const url = api(`/events/${event.id}/integrations/active_campaign/add_tag`)
  return (tag: ActiveCampaignTag) => {
    try {
      client.post(url, {
        id: tag.id,
      })
    } catch {
      // Ignore errors, failing to add a tag should
      // not break the app.
    }
  }
}
